import { HourglassTopRounded } from "@mui/icons-material";

export const hourglassTop = (props) => {
  return <HourglassTopRounded {...props} />;
};
